import axios from "axios";

const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://app.qrscripts.in/api"    
    : "http://localhost:5001/api";

const API = axios.create({ baseURL: API_BASE_URL });

export default API;
